<template>
	<div>
		<meta
			name="viewport"
			content="width=device-width, initial-scale=1.0, maximum-scale=1.0, 
     user-scalable=0"
		/>
		<qrcode-stream
			:track="selected.value"
			:torch="torchActive"
			@init="logErrors"
			@decode="onDecode"
			:camera="camera"
			class="qrReader"
			:key="qrReaderKey"
		>
			<!-- 상단 메뉴 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrHeadxs' : 'qrHead'">
				<v-flex class="qrTitle">음료 QR Reader</v-flex>
				<v-spacer />
			</v-layout>
			<!-- qr 인증박스 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrMiddlexs' : 'qrMiddle'" align-center justify-center>
				<div :class="nowWidth"></div>
			</v-layout>
			<!-- 촬영 버튼 -->
			<v-btn color="primary2" style="position: fixed; bottom: 0px;" dark @click="switchCamera" block height="50px">
				<span style="font-size: 20px;"> 카메라 전환({{ camera === 'front' ? '앞' : camera === 'auto' ? '자동' : '뒤' }})</span></v-btn
			>
		</qrcode-stream>
		<sweetAlert :dialog="sweetInfo" @close_active="sweetInfo.title === '오류발생' ? windowClose() : ''" />
	</div>
</template>

<script>
import { sweetAlert } from '@/components'
export default {
	components: {
		sweetAlert,
	},
	data() {
		const options = [
			{ text: 'nothing (default)', value: undefined },
			{ text: 'outline', value: this.paintOutline },
			{ text: 'centered text', value: this.paintCenterText },
			{ text: 'bounding box', value: this.paintBoundingBox },
		]

		const selected = options[1]

		return {
			qrReaderKey: 0,
			business: {},
			sweetInfo: {
				open: false,
				title: '',
				content: ``,
				modalIcon: 'info',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			selected,
			options,
			groupCodes: [],
			//카메라 방향
			camera: 'front',
			//카메라 유무 체크
			noRearCamera: false,
			noFrontCamera: false,
			// flash light
			torchActive: false,
			torchNotSupported: false,
			// 찍은 qr 정보
			result: null,
			// 인증완료 카드 model
			alertCard1: false,
			alertCard2: false,
			alertCard3: false,
			alertCard4: false,
			// 촬영 버튼
			btn: {
				block: true,
				dark: true,
				height: '7%',
				color: '#7DC269',
				class: 'qrCapture',
				icon: true,
				iconSize: '24px',
			},

			// info 다이어로그
			qrinfoDialog: { dialog: false, title: 'Test Business Name' },
			// 음성 재생 데이터
			voiceList: [],
			greetingSpeech: new window.SpeechSynthesisUtterance(),
			synth: window.speechSynthesis,
			/// user 이름
			userData: {},
			greetingUser: '',
			greetingUser2: '이미 인증되었습니다',
			greetingUser1: '예약일시를 확인하세요',
			greetingNum: '',
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
			groupdata: {},
			/// 상담자 reserve user 데이터
			reservedUser: {},

			// 오늘 대기 번호
			waitNum: '',

			title: '', // (reservedays) 사업지명
			tplCode: '', // tplCode
			messageData: {}, // 알림톡 전송 정보
			originMsg: '',
			voiceSystemsList: {
				StartWork: { voice: '', version: 0 },
				LeaveWork: { voice: '', version: 0 },
				AlreadyStartWork: { voice: '', version: 0 },
				AlreadyLeaveWork: { voice: '', version: 0 },
			},
			ourCoords: {
				//서울 시청 좌표
				latitude: 37.5666263, //위도
				longitude: 126.9783924, //경도
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth
			})
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			if (this.windowWidth <= 375) {
				return 'middleSquarexxxs'
			} else if (this.windowWidth <= 375) {
				return 'middleSquarexxs'
			} else if (this.windowWidth <= 425) {
				return 'middleSquarexs'
			} else if (this.windowWidth <= 768) {
				return 'middleSquaresm'
			} else if (this.windowWidth <= 1024) {
				return 'middleSquaremd'
			} else {
				return 'middleSquare'
			}
		},
		nowHeight() {
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			return this.windowHeight
		},
	},
	async mounted() {
		await this.open_disable_dialog_first({
			title: '실행',
			content: '음료인증 QR Reader가 실행되었습니다.\nQR코드를 인식하여 음료인증을 진행해 주세요.',
		})
		await this.playSound('/tingtong.wav')
	},
	methods: {
		playSound(soundFile) {
			const audio = new Audio(soundFile)
			audio.volume = 1.0 // 볼륨 최대로 설정
			audio.load()

			// 사용자 상호작용 후 재생 (모바일 브라우저 정책)
			const playPromise = audio.play()

			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						console.log('Audio played successfully')
					})
					.catch(error => {
						// 자동 재생 실패 시 - 사용자 클릭/터치 필요
						console.error('Audio play failed:', error)
						// 모바일에서는 사용자 제스처가 필요할 수 있음
						document.addEventListener(
							'click',
							() => {
								audio.play()
							},
							{ once: true },
						)
					})
			}
		},
		windowClose() {
			window.open('', '_self').close()
			this.$router.push({ name: 'dashBoard' })
		},

		open_disable_dialog_first(data, info) {
			// 불가 팝업 열기

			this.sweetInfo.title = data.title
			this.sweetInfo.content = data.content
			if (data.profile) this.sweetInfo.profile = data.profile
			if (!info) this.sweetInfo.modalIcon = `info`
			else this.sweetInfo.modalIcon = info
			this.sweetInfo.open = true
		},
		open_disable_dialog(data, info) {
			// 불가 팝업 열기

			this.sweetInfo.title = data.title
			this.sweetInfo.content = data.content
			if (data.profile) this.sweetInfo.profile = data.profile
			if (!info) this.sweetInfo.modalIcon = `info`
			else this.sweetInfo.modalIcon = info
			this.sweetInfo.open = true

			// 사운드 재생
			if (info === 'error') {
				this.playSound('/error.mp3')
			} else {
				this.playSound('/tingtong.wav')
			}
		},
		voice(voice) {
			this.greetingSpeech.text = `${voice}`
			// 한국어 목소리 선택
			let index = this.voiceList.findIndex(e => e.name === 'Google 한국의')
			this.greetingSpeech.voice = this.voiceList[index]

			this.synth.speak(this.greetingSpeech)
		},
		updateUser_NoAuth(users) {
			const data = {
				id: users.id,
				vacationsDays: users.vacationsDays + 1,
			}
			this.$store.dispatch('updateUser_NoAuth', data).then(() => {})
		},
		turnOffAlert() {
			setTimeout(() => {
				this.alertModal4.dialog = false
			}, 2000)
		},
		paintOutline(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

				ctx.strokeStyle = 'yellow'

				ctx.beginPath()
				ctx.moveTo(firstPoint.x, firstPoint.y)
				for (const { x, y } of otherPoints) {
					ctx.lineTo(x, y)
				}
				ctx.lineTo(firstPoint.x, firstPoint.y)
				ctx.closePath()
				ctx.stroke()
			}
		},

		paintBoundingBox(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const {
					boundingBox: { x, y, width, height },
				} = detectedCode

				ctx.lineWidth = 2
				ctx.strokeStyle = '#007bff'
				ctx.strokeRect(x, y, width, height)
			}
		},

		paintCenterText(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const { boundingBox, rawValue } = detectedCode

				const centerX = boundingBox.x + boundingBox.width / 2
				const centerY = boundingBox.y + boundingBox.height / 2

				const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

				ctx.font = `bold ${fontSize}px sans-serif`
				ctx.textAlign = 'center'

				ctx.lineWidth = 3
				ctx.strokeStyle = '#35495e'
				ctx.strokeText(detectedCode.rawValue, centerX, centerY)

				ctx.fillStyle = '#5cb984'
				ctx.fillText(rawValue, centerX, centerY)
			}
		},

		switchCamera() {
			//카메라 변경
			switch (this.camera) {
				case 'front':
					this.camera = 'rear'
					break
				case 'rear':
					this.camera = 'front'
					break
				case 'auto':
					this.camera = 'front'
					break
			}
		},
		async logErrors(promise) {
			try {
				//카메라 변경
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
				}

				console.error(error)
			}
			try {
				//플래시라이트 on off
				const { capabilities } = await promise

				this.torchNotSupported = !capabilities.torch
			} catch (error) {
				console.error(error)
			}
			try {
				//qr 읽기
				await promise
			} catch (e) {
				console.error(e)
			}
		},
		async QRUser(content) {
			if (content.indexOf('/') === -1) {
				this.open_disable_dialog(
					{
						title: '인증오류',
						content: `잘못된 QR코드입니다.\n다시 시도해 주세요.`,
					},
					'error',
				)
				return
			}
			if (content.split('/').length !== 2) {
				this.open_disable_dialog(
					{
						title: '인증오류',
						content: `잘못된 QR코드입니다.\n다시 시도해 주세요.`,
					},
					'error',
				)
				return
			}
			const data = {
				code: this.$route.params.code,
				phone: content.split('/')[0],
			}
			await this.$store.dispatch('reserveusers', data).then(res => {
				this.$store.state.loading = false
				if (res.data.reserveusers.length === 0) {
					this.open_disable_dialog(
						{
							title: '인증오류',
							content: `방문등록된 QR이 아닙니다.\n방문등록 후 이용해 주세요.`,
						},
						'error',
					)
					return
				}

				// 한국 시간 기준 오늘 날짜 (YYYY-MM-DD 형식)
				const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }))
				const todayStr = today.toISOString().split('T')[0]

				// rdate가 오늘 날짜인 데이터만 필터링
				const todayReservation = res.data.reserveusers.find(item => {
					if (item && item.rdate) {
						const rdate = new Date(item.rdate).toISOString().split('T')[0]
						return rdate === todayStr
					}
					return false
				})
				if (todayReservation) {
					if (todayReservation.receiveInformation) {
						this.open_disable_dialog(
							{
								title: '음료QR중복',
								content: `[${todayReservation.name}님] 이미 음료를 제공받았습니다.`,
							},
							'error',
						)
					} else {
						this.$store.dispatch('updateReserveuser', { id: todayReservation.id, receiveInformation: true }).then(() => {
							{
								this.open_disable_dialog({
									title: '음료QR인증',
									content: `[${todayReservation.name}님] 음료 제공 인증 되었습니다. \n맛있게 드세요.`,
								})
							}
						})
					}
				} else {
					this.open_disable_dialog(
						{
							title: '인증오류',
							content: `[${res.data.reserveusers[0].name}님] 금일 등록된 QR이 아닙니다.\n방문등록 후 이용해 주세요.`,
						},
						'error',
					)
					return
				}
			})

			this.pause()
			setTimeout(() => {
				this.unpause()
			}, 500)
			setTimeout(() => {
				this.sweetInfo.open = false
			}, 1000)
		},
		async onDecode(content) {
			this.QRUser(content)
			setTimeout(() => {
				this.qrReaderKey++
			}, 1000)
		},
		unpause() {
			this.camera = 'front'
		},
		pause() {
			this.camera = 'off'
		},
		timeout(ms) {
			return new Promise(resolve => {
				window.setTimeout(resolve, ms)
			})
		},
	},
}
</script>

<style lang="scss">
.qrReader {
	height: 100vh !important;
}
/// 상단 메뉴 css
.qrHead {
	height: 9%;
	padding: 2vh 0px 0vw 2vw;
}
.qrHeadxs {
	height: 7%;
	padding: 2vh 0px 0vw 2vw;
}
// 상단 사업지명
.qrTitle {
	font-size: 4vh;
	font-weight: bold;
	color: white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
.qrTitlexs {
	font-size: 3vh;
	font-weight: bold;
	color: white;
	border: 3px solid white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
// 상단 버튼
.iconBtn {
	cursor: pointer;
	margin: 0px 5vw 0px 0px;
}
/// 인증완료 메세지 div
.confirmation {
	z-index: 1;
	position: inherit;
	width: 100%;
	text-align: -webkit-center;
	padding-top: 4vh;
}
/// 인증완료 메세지 카드
.alertCard1 {
	opacity: 0.7;
	width: 25vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
.alertCard2 {
	color: white !important;
	opacity: 0.7;
	width: 40vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
/// qr 인식 layout
.qrMiddle {
	z-index: 2;
	height: 84%;
}
.qrMiddlexs {
	z-index: 2;
	height: 86%;
}
// qr 인식 박스
.middleSquare {
	border: 4px dashed yellow;
	width: 30%;
	height: 69.5%;
}
.middleSquaremd {
	border: 4px dashed yellow;
	width: 48vw;
	height: 55vh;
}
.middleSquaresm {
	border: 4px dashed yellow;
	width: 58vw;
	height: 50vh;
}
.middleSquarexs {
	border: 4px dashed yellow;
	width: 63vw;
	height: 30vh;
}
.middleSquarexxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 30vh;
}
.middleSquarexxxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 25.5vh;
}
.hideBtn {
	display: none;
}
</style>
